module.exports = __webpack_public_path__ + "img/active-points.a228e77.svg";